// extracted by mini-css-extract-plugin
export default {"devices-table-header":"Devices_devices-table-header__qR0Sy","devices-table":"Devices_devices-table__Qb7GP"};